import { render, staticRenderFns } from "./TranspasarPreguntas.vue?vue&type=template&id=1c132ea1"
import script from "./TranspasarPreguntas.vue?vue&type=script&lang=js"
export * from "./TranspasarPreguntas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports